(function() { module.exports = window["wp"]["primitives"]; }());